export const citiesRequestDataMapping = (data) => {
    const addObjectNameFromValue = (item) => ({...item, name: item?.value});

    const mappedData = {
        items: [...data.items].map((item) => addObjectNameFromValue(item)),
    };

    return mappedData;
};
